 import { Injectable } from '@angular/core'; 
@Injectable({
  providedIn: 'root',
})
export class NotesHelper { 
  constructor() { }
  isHtmlContent(value: string | null | undefined): boolean { 
    return !!value && ( /<[^>]+>/.test(value) || /&lt;[^&gt;]+&gt;/.test(value) || /<?[^>]*>/.test(value));
  }
  decodeHtmlEntities(encoded: string): string {
    const entityMap: { [key: string]: string } = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'",
      '&#x2F;': '/',
      '&#x5C;': '\\',
      '&#10;': '<br/>',
      '&#96;': '`'
    };

    let decoded = encoded;

    // Decode repeatedly in case of nested encodings
    let prev;
    do {
      prev = decoded;
      for (const [entity, char] of Object.entries(entityMap)) {
        decoded = decoded.replace(new RegExp(entity, 'g'), char);
      }
    } while (decoded !== prev); 
    return decoded;
  }
  parsefromString(value:any){
    const doc = new DOMParser().parseFromString(value, 'text/html');
    let content=doc.body.innerHTML ?? doc.documentElement.textContent;    
    return this.decodeHtmlEntities(content);
  }
  parsefromContent(value:any){
    const doc = new DOMParser().parseFromString(value, 'text/html');
    let content=  doc.documentElement.textContent;    
    return this.decodeHtmlEntities(content);
  }
  encodeUnicodeText(text: string): string {
    const formattedNotes = text.replace(/\n/g, '<br/>');
    // Use TextEncoder to get a Uint8Array of UTF-8 bytes
    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(formattedNotes);
  
    // Convert Uint8Array to a string of bytes for btoa
    let binaryString = '';
    utf8Bytes.forEach((byte) => {
      binaryString += String.fromCharCode(byte);
    });
  
    return btoa(binaryString);
  }
  isEmptyOrWhitespace(str) {
    return str === null || str === undefined || String(str||'').trim().length === 0;
  }
  decodeEntities(value: string | null | undefined): string {
    const t = document.createElement('textarea');
    t.innerHTML = value || '';
    return t.value;
   }
   decodeUnicode(base64: string): string {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  }
  
}